export default {
  pt: {
    SORT_BY: 'Organizar por',
    SELECT_DOWNLOADABLE: 'Selecione para download',
    NO_RESULTS_FOUND: 'Ops, nenhum resultado encontrado',
    ALL_DOWNLOADABLE: 'Tudo para download',

    HERO_TITLE: 'Para download',
    HERO_DESCRIPTION:
      'Confira os melhores recursos de seu interesse para estar na tendência',

    SEO_TITLE: 'Para download | Crehana para empresas',
    SEO_DESCRIPTION:
      'Desenhamos treinamentos ágeis com profissionais do Google, Facebook, Amazon e muito mais. Aprimore as habilidades de sua equipe em design, dados, transformação digital, softskills e muito mais.',

    ORDER_ALL: 'Todo mundo',
    ORDER_RECENT: 'O mais recente',
    ORDER_POPULARITY: 'O mais popular',
    ORDER_OLDER: 'O mais velho',
  },
};
